// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

const ContractUpgradeController = function
    ($rootScope, $scope, $location, $routeParams, $http, $filter, ProductInfo, Contract, Order, Component, gettext, 
     gettextCatalog, ContractTimeDetails, PUtill, EmailNotificationsTemplatesByEventCategory, 
     babelFilter, ContractUpgradeChangesMediator, ComponentSubscriptionByContract, ComponentSubscription, ComponentUsage,
     DiscountSubscriptionByContract, ContractRatedItems, Coupons, pdateFilter,
     ContractUnbilledMeteredLineItemsForUpgradeProcess, ContractEndDate, DatepickerUtils)
{

    ProductInfo.getProductInfoForContract($routeParams.contractId, true, function(productInfo, error) {
        if (error) {
            console.error("Failed to fetch product info:", error);
            return;
        }
        if (productInfo) {
            $scope.fullProductInfo = productInfo;
            $scope.oldContract = Contract.get({ contractId: $routeParams.contractId }, function () {
                loadContract(productInfo);
                loadSelectableItems(productInfo);
            });

            $scope.newRatedItem.TaxPolicyId = productInfo.getDefaultTaxPolicyId();
            $scope.canTrialModeBeApplied = function () {
                let plan = productInfo.PlanById($scope.order.Cart.PlanId);
                return !!(plan && plan.TrialPeriod && plan.TrialPeriod.Quantity !== 0);
            };
        }
    });

    // Options of the searchable "add component / discount / metered usage" dropdowns
    $scope.selectableComponents = [];
    $scope.selectableDiscounts = [];
    $scope.selectableMeteredComponents = [];

    function loadSelectableItems(productInfo) {
        const visibleComponents = productInfo.Components.filter(component => !component.Hidden);

        $scope.selectableComponents = visibleComponents.filter($scope.isNonMetered);
        $scope.selectableMeteredComponents = visibleComponents.filter($scope.isMetered);
        $scope.selectableDiscounts = (productInfo.DiscountsByPlanGroupId($scope.oldContract.PlanGroupId) || [])
            .filter(discount => !discount.Hidden);
    }

    function loadContract(productInfo) {
        if ($scope.oldContract) {
            let oldContract = $scope.oldContract;

            // If we are not back from confirmation
            if (!$scope.order.ChangeDate) {
                $scope.order.ChangeDate = Contract.getDateToPhaseStartTimeAdjusted($scope.oldContract, DatepickerUtils.toBerlinMidnightTime(new Date()));
            }

            // If we are not back from confirmation
            if (!$scope.order.Cart.Quantity) {
                $scope.order.Cart.Quantity = oldContract.CurrentPhase.Quantity;
            }

            if ($scope.oldContract.PlanVariantId) {
                $scope.plan = productInfo.PlanById(oldContract.PlanId);
                $scope.planVariant = productInfo.PlanVariantById(oldContract.PlanVariantId);
                if ($scope.planVariant) {
                    var periodEnd = oldContract.CurrentPhase.Type === 'Trial' ? $scope.planVariant.ContractPeriod : $scope.planVariant.LaterContractPeriod;
                    $scope.oldContractPeriodEnd = PUtill.addPeriod(periodEnd, oldContract.CurrentPhase.StartDate);
                }

                ContractUpgradeChangesMediator.currency = $scope.oldContract.Currency;
            }

            $scope.priceList = productInfo.PriceListById(oldContract.PriceListId);
            ContractUpgradeChangesMediator.priceListId = oldContract.PriceListId;

            // Check if contract status == 'Ended' then setup Contract EndDate
            if (oldContract.LifecycleStatus === 'Ended') {
                $scope.oldContractPeriodEnd = oldContract.EndDate;
            } else {
                ContractEndDate.get({ contractId: $routeParams.contractId }, function (response) {
                    $scope.oldContractPeriodEnd = response.EndDate;
                });
            }
        }
    }
    
    // Text of tooltips
    $scope.contractUpgradeTooltips = Object.freeze({
        "InheritStartDate": gettext("Can be chosen if the contract should continue to run seamlessly without restarting the contract terms and cancellation periods as a result of the upgrade at the time of the change."),
        "TriggerInterimBilling": gettext("Can be choosen to bill metered usage components that have already been posted but not yet billed directly with the up/downgrade."),
        "RequirePayment": gettext("Can be choosen if the up-downgrade requires a valid payment method attached to the contract"),
        "PriceList": gettext("Price list change do not influence on Billing Precision for contract")
    });
    
    $scope.componentSubscriptions = [];
    $scope.discountSubscriptions = [];
    $scope.meteredUsages = [];
    $scope.ratedItems = [];
    let dataPromise = [];
    // Fetching product info for further processing
    {
        dataPromise.push(ComponentSubscriptionByContract.query({contractId: $routeParams.contractId}).$promise.then(function (response) {
            $scope.componentSubscriptions = response;
            $scope.componentSubscriptions.forEach(function (component) {
                component._previousEndDate = component.EndDate;
            });
        }));
        dataPromise.push(DiscountSubscriptionByContract.query({contractId: $routeParams.contractId}).$promise.then(function (response) {
            $scope.discountSubscriptions = response;
            $scope.discountSubscriptions.forEach(function (discount) {
                discount._previousEndDate = discount.EndDate;
            });
        }));
        dataPromise.push(ComponentUsage.query({contractId: $routeParams.contractId}).$promise.then(function (response) {
            $scope.meteredUsages = response.filter(function (meteredUsage) { return !meteredUsage.BilledOn && !meteredUsage.BilledInvoiceId; });
        }));
        dataPromise.push(ContractRatedItems.query({contractId: $routeParams.contractId}).$promise.then(function (response) {
            $scope.ratedItems = response.filter(function (ratedItem) { return !ratedItem.LineItemId; });
        }));
    }

    function TrialMode(id, name){
        this.id = id;
        this.name = $filter('translate')(name);
    }

    $scope.trialModes = [
        new TrialMode("Enabled", "Grant Trial"),
        new TrialMode("Disabled", "Disable Trial"),
        new TrialMode("ReplaceRemainder", "Upgrade existing Trial"),
    ];

    switch (ContractUpgradeChangesMediator.trialMode.id) {
        case $scope.trialModes[0].id:
            $scope.trialMode = $scope.trialModes[0];
            break;
        case $scope.trialModes[2].id:
            $scope.trialMode = $scope.trialModes[2];
            break;
        default:
            $scope.trialMode = $scope.trialModes[1];
            break;
    }

    // Watching previous editing info, e.g. "Back" button
    // on confirmation page was pressed
    if (!ContractUpgradeChangesMediator.order.Id) {
        $scope.order = new Order();
        $scope.order.ContractId = $routeParams.contractId;
        $scope.order.EmailTemplateExternalId = null;
        $scope.order.Cart = {
            MeteredUsages: [], ComponentSubscriptions: [], DiscountSubscriptions: [], RatedItems: [],
            CouponCode: "", EndComponentSubscriptions: [], EndDiscountSubscriptions: [],
            DeletedMeteredUsages: [], DeletedRatedItems: [] };

        $scope.datePresetName = "";
        $scope.requirePayment = true;
        $scope.onAccount = false;
    } else {
        $scope.order = ContractUpgradeChangesMediator.order;
        $scope.order.Cart.EndComponentSubscriptions = [];
        $scope.order.Cart.EndDiscountSubscriptions = [];
        $scope.order.Cart.DeletedMeteredUsages = [];
        $scope.order.Cart.DeletedRatedItems = [];

        $scope.datePresetName = ContractUpgradeChangesMediator.datePresetName;
        $scope.requirePayment = ContractUpgradeChangesMediator.requirePayment;
        $scope.onAccount = ContractUpgradeChangesMediator.onAccount;

        Promise.all(dataPromise).then(function () {
            ContractUpgradeChangesMediator.recurringComponentUpdates.forEach(function (item) {
                let foundIndex = $scope.componentSubscriptions.findIndex(function (existingItem) { return existingItem.Id === item.Id; });
                
                if (foundIndex !== -1) {
                    $scope.componentSubscriptions[foundIndex] = item;
                } else if (item.Id && item.IsNewComponent === undefined) {
                    item.IsActiveUnbilled = undefined;
                    $scope.componentSubscriptions.push(item);
                }
            });
            ContractUpgradeChangesMediator.discountUpdates.forEach(function (item) {
                let foundIndex = $scope.discountSubscriptions.findIndex(function (existingItem) { return existingItem.Id === item.Id; });
                
                if (foundIndex !== -1) {
                    $scope.discountSubscriptions[foundIndex] = item;
                } else if (item.Id && !item._fromCoupon && item.IsNewDiscount === undefined) {
                    $scope.discountSubscriptions.push(item);
                    
                    if (item.IsCancellingNow) {
                        $scope.order.Cart.EndDiscountSubscriptions.push(item.Id);
                    }
                } else if (item.IsNewDiscount) {
                    if (!ContractUpgradeChangesMediator.discountUpdates.includes(item)) {
                        ContractUpgradeChangesMediator.addDiscountComponentUpdates(item);
                    }
                }
            });
            ContractUpgradeChangesMediator.meteredComponentsUpdates.forEach(function (item) {
                let foundIndex = $scope.meteredUsages.findIndex(function (existingItem) { return existingItem.Id === item.Id; });
                
                if (foundIndex !== -1) {
                    $scope.meteredUsages[foundIndex] = item;
                } else if (item.Id && item.IsNewMeteredUsage === undefined) {
                    $scope.meteredUsages.push(item);
                }
            });
            ContractUpgradeChangesMediator.ratedItemsUpdates.forEach(function (item) {
                let foundIndex = $scope.ratedItems.findIndex(function (existingItem) { return existingItem.Id === item.Id; });
                
                if (foundIndex !== -1) {
                    $scope.ratedItems[foundIndex] = item;
                } else if (item.Id) {
                    $scope.ratedItems.push(item);
                }
            });

            ContractUpgradeChangesMediator.reset();
        });
    }

    $scope.showInvalidCouponLabel = false;
    $scope.componentService = Component;

    EmailNotificationsTemplatesByEventCategory.query({ category: 'OrderSucceeded'}).$promise.then(function (response) {
        $scope.emailTemplates = response;
        response.every(function (item){            
                if(item.DefaultForSubEvents)
                    return item.DefaultForSubEvents.every(function (subEvents){
                        if(subEvents==="UpDowngrade"){
                            $scope.order.EmailTemplateExternalId=item.ExternalId;
                            return false;
                        }
                        return true;
                    });
                return true;
            }            
        );
    });

    // Components management
    {
        $scope.isNonMetered = function (item) {
            return item.ComponentType !== 'Metered' && $scope.oldContract && item.PlanGroupId === $scope.oldContract.PlanGroupId;
        };
        $scope.addComponentSubscription = function () {
            $scope.newComponentSubscription.ProductOverride = SetupProductOverride($scope.newComponentSubscription.ProductOverride);
            
            if ($scope.newComponentSubscription.ComponentId) {
                $scope.newComponentSubscription.StartDate = $scope.order.ChangeDate;
                
                let newComponentSubscriptionCopy = JSON.parse(angular.toJson($scope.newComponentSubscription));
                $scope.order.Cart.ComponentSubscriptions.push(newComponentSubscriptionCopy);

                $scope.clearNewComponentSubscription();
            }
        };
        $scope.deleteComponent = function (hashKey) {
            $scope.order.Cart.ComponentSubscriptions = $scope.order.Cart.ComponentSubscriptions.filter(
                function (item) { return item.$$hashKey !== hashKey; });
            ContractUpgradeChangesMediator.removeRecurringComponentUpdates(hashKey);
        };
        $scope.clearNewComponentSubscription = function () {
            $scope.newComponentSubscription = {
                Quantity: 1,
                ProductOverride: { Name: "", Description: "", PricePerUnit: "" },
                IsNewComponent: true
            };
        }
    }
    
    $scope.setCancelOrEnd = function (item) {
        if ($scope.datePresetName === "Now" || new Date($scope.order.ChangeDate) <= new Date()) {
            item.IsEndingNow = true;
            item.IsCancellingNow = false;
        }
        else {
            item.IsCancellingNow = true;
            item.IsEndingNow = false;
        }
    };
    $scope.cancelItem = function (item) {
        item._previousEndDate = angular.copy(item.EndDate);
        item.EndDate = $scope.order.ChangeDate;
        
        $scope.setCancelOrEnd(item);
    };
    $scope.revertCancelItem = function (item) {
        item.EndDate = item._previousEndDate;
        item._previousEndDate = undefined;
        item.IsCancellingNow = false;
        item.IsEndingNow = false;
    };

    // Discounts & coupon management
    {
        $scope.isNewCouponRequired = false;
        $scope.addDiscountSubscription = function () {
            if ($scope.newDiscountSubscription && $scope.newDiscountSubscription.DiscountId) {
                $scope.newDiscountSubscription.StartDate = $scope.order.ChangeDate;

                let newDiscountSubscriptionCopy = JSON.parse(angular.toJson($scope.newDiscountSubscription));
                $scope.order.Cart.DiscountSubscriptions.push(newDiscountSubscriptionCopy);

                $scope.clearNewDiscountSubscription();
            }
        };
        $scope.addDiscountSubscriptionByCoupon = function () {
            if (!$scope.order.Cart.CouponCode) {
                $scope.isNewCouponRequired = true;
                $scope.showInvalidCouponLabel = false;
            } else {
                Coupons.query({
                    couponCode: $scope.order.Cart.CouponCode,
                    enabled: true,
                    active: true
                }).$promise.then(function (response) {
                    let coupons = response;

                    if (coupons.length !== 0) {
                        coupons.forEach(function (coupon) {
                            let newDiscount = angular.copy($scope.fullProductInfo.DiscountById(coupon.DiscountId));

                            newDiscount.StartDate = $scope.order.ChangeDate;
                            newDiscount.Description = newDiscount.Description._c;
                            newDiscount.DiscountId = newDiscount.Id;
                            newDiscount.IsNewDiscount = true; // Maybe this property is not needed?
                            newDiscount._fromCoupon = true;
                            $scope.order.Cart.DiscountSubscriptions = $scope.order.Cart.DiscountSubscriptions.filter(function (item) { return !item._fromCoupon; });
                            $scope.order.Cart.DiscountSubscriptions.push(newDiscount);
                            $scope.couponLabelMessage= coupon.Description._c;
                        });
                        $scope.showInvalidCouponLabel = false;

                    } else {
                        $scope.couponLabelMessage = gettext("The coupon code is invalid");
                        $scope.showInvalidCouponLabel = true;
                    }
                });
                $scope.isNewCouponRequired = false;
            }
        };
        $scope.isDiscountPeriodUnique = function (discount) {
            let isDiscountsPeriodsEqual = function (d1, d2) {
                let startsEqual = (!d1.StartDate && !d2.StartDate) ||
                    (pdateFilter(d1.StartDate) === pdateFilter(d2.StartDate));
                let endsEqual = (!d1.EndDate && !d2.EndDate) ||
                    (pdateFilter(d1.EndDate) === pdateFilter(d2.EndDate));

                return endsEqual && startsEqual; // UUU clarify
            };

            // Check existing ones
            for (let index = 0; index < $scope.discountSubscriptions.length; ++index) {
                let currentDiscount = $scope.discountSubscriptions[index];
                
                if (((!currentDiscount.IsCancellingNow && !currentDiscount.IsEndingNow) || !currentDiscount._fromCoupon) &&
                    currentDiscount.DiscountId === discount.DiscountId) {
                    if (isDiscountsPeriodsEqual(currentDiscount, discount)) {
                        return false;
                    }
                }
            }

            // Check newly added discounts
            for (let index = 0; index < $scope.order.Cart.DiscountSubscriptions.length; ++index) {
                let currentDiscount = $scope.order.Cart.DiscountSubscriptions[index];
                
                if (discount !== currentDiscount && currentDiscount.DiscountId === discount.DiscountId) {
                    if (isDiscountsPeriodsEqual(currentDiscount, discount)) {
                        return false;
                    }
                }
            }

            return true;
        };
        $scope.deleteDiscountSubscription = function (hashKey) {
            $scope.order.Cart.DiscountSubscriptions = $scope.order.Cart.DiscountSubscriptions.filter(
                function (item) { return item.$$hashKey !== hashKey; });
            ContractUpgradeChangesMediator.removeDiscountComponentUpdates(hashKey);
        };
        $scope.clearNewDiscountSubscription = function () {
            $scope.newDiscountSubscription = { IsNewDiscount: true };
        }
    }

    // Metered usages management
    {
        $scope.isMetered = function (item) {
            return item.ComponentType === 'Metered' && $scope.oldContract && item.PlanGroupId === $scope.oldContract.PlanGroupId;
        };
        $scope.addMeteredUsage = function () {
            $scope.newMeteredUsage.ProductOverride = SetupProductOverride($scope.newMeteredUsage.ProductOverride);
            
            if ($scope.newMeteredUsage.ComponentId) {
                $scope.newMeteredUsage.DueDate = $scope.order.ChangeDate;

                let newMeteredUsageCopy = JSON.parse(angular.toJson($scope.newMeteredUsage));
                $scope.order.Cart.MeteredUsages.push(newMeteredUsageCopy);

                $scope.clearNewMeteredUsage();
            }
        };
        $scope.deleteNewMeteredUsage = function (hashKey) {
            $scope.order.Cart.MeteredUsages = $scope.order.Cart.MeteredUsages.filter(
                function (item) { return item.$$hashKey !== hashKey; });
            ContractUpgradeChangesMediator.removeMeteredComponentUpdates(hashKey);
        };
        $scope.deleteExistingMeteredUsage = function (index) {
            $scope.meteredUsages[index].IsDeletedNow = true;
        };
        $scope.restoreExistingMeteredUsage = function (index) {
            $scope.meteredUsages[index].IsDeletedNow = undefined;
        };
        $scope.clearNewMeteredUsage = function () {
            $scope.newMeteredUsage = {
                Quantity: 1,
                ProductOverride: { Name: "", Description: "", PricePerUnit: "" },
                IsNewMeteredUsage: true
            };
        }
    }

    // Rated items management
    {
        $scope.addRatedItem = function () {
            if ($scope.newRatedItem.Quantity && $scope.newRatedItem.TaxPolicyId &&
                $scope.newRatedItem.PricePerUnit && $scope.newRatedItem.Description) {
                let newRatedItemCopy = JSON.parse(angular.toJson($scope.newRatedItem));
                $scope.order.Cart.RatedItems.push(newRatedItemCopy);
                $scope.clearNewRatedItem();
            }
        };
        $scope.deleteNewRatedItem = function (hashKey) {
            $scope.order.Cart.RatedItems = $scope.order.Cart.RatedItems.filter(
                function (item) { return item.$$hashKey !== hashKey; });
            ContractUpgradeChangesMediator.removeRatedItemsComponentUpdates(hashKey);
        };
        $scope.deleteExistingRatedItem = function (index) {
            $scope.ratedItems[index].IsDeletedNow = true;
        };
        $scope.restoreExistingRatedItem = function (index) {
            $scope.ratedItems[index].IsDeletedNow = undefined;
        };
        $scope.clearNewRatedItem = function () {
            $scope.newRatedItem = { Quantity: 1, PricePerUnit: "", IsNewRatedItem: true };
        }
    }

    $scope.isQuantityBase = function () {
        return $scope.newComponentSubscription.ComponentId && ($scope.productInfo.ComponentById($scope.newComponentSubscription.ComponentId).ComponentType == 'QuantityBased');
    };
    $scope.ResetComponentSubscriptionProductOverride = function () {
        $scope.newComponentSubscription.ProductOverride = { Name: "", Description: "", PricePerUnit: "" };
    };
    $scope.ResetMeteredUsageProductOverride = function () {
        $scope.newMeteredUsage.ProductOverride = { Name: "", Description: "", PricePerUnit: "" };
    };
    $scope.GetComponentName = function (baseComponent, newComponent) {        
        const isOverrideNameExist = baseComponent.Id &&
            newComponent &&
            baseComponent.Id === newComponent.ComponentId &&
            newComponent.ProductOverride &&
            newComponent.ProductOverride.Name &&
            newComponent.ProductOverride.Name !== "";
        
        if (isOverrideNameExist) {
            return `${baseComponent.ExternalId} ${newComponent.ProductOverride.Name} - ${babelFilter(baseComponent.Name)}`
        }
        
        return `${baseComponent.ExternalId} ${babelFilter(baseComponent.Name)}`
    };

    const SetupProductOverride = function (productOverride) {        
        if (productOverride.Name === "" &&
            productOverride.PricePerUnit === "" &&
            productOverride.Description === "") {
            productOverride = null;
        }
        if (productOverride && productOverride.Name === "") {
            delete productOverride.Name;
        }
        if (productOverride && productOverride.pricePerUnit === "") {
            delete  productOverride.PricePerUnit;
        }
        if (productOverride && productOverride.Description === "") {
            delete productOverride.Description;
        }
        return productOverride;
    };

    // Statuses
    {
        $scope.ITEM_STATUS = Object.freeze({
            'Active': 'Active',
            'Added': 'Added',
            'Cancelling': 'Cancelling',
            'NotBilled': 'Not Billed',
            'Billed': 'Billed'
        });

        $scope.filterExistingComponents = function (recurringComponent) {
            return $scope.isRecurringComponentActive(recurringComponent);
        };
        $scope.isRecurringComponentActive = function (recurringComponent) {            
            let recurringComponentStartDate = new Date(Date.parse(recurringComponent.StartDate)).setUTCMilliseconds(0);
            let recurringComponentEndDate = new Date(Date.parse(recurringComponent._previousEndDate)).setUTCMilliseconds(0);
            let currentChosenDate = new Date(Date.parse($scope.order.ChangeDate)).setUTCMilliseconds(0);

            if (recurringComponent.IsCancellingNow || recurringComponent.IsEndingNow) {
                return currentChosenDate >= recurringComponentStartDate &&
                    (recurringComponent._previousEndDate === undefined || recurringComponentEndDate > currentChosenDate);
            }

            return (recurringComponent._previousEndDate === undefined || recurringComponentEndDate > currentChosenDate) &&
                recurringComponentStartDate <= currentChosenDate &&
                recurringComponentStartDate !== recurringComponentEndDate;
        };
        $scope.getRecurringComponentStatusAsString = function (recurringComponent) {
            if (recurringComponent.IsNewComponent || recurringComponent.IsNewDiscount) {
                return $scope.ITEM_STATUS['Added'];
            }

            if (recurringComponent.IsCancellingNow || recurringComponent.IsEndingNow) {
                return $scope.ITEM_STATUS['Cancelling'];
            }

            return $scope.ITEM_STATUS['Active'];
        };
        $scope.getMeteredUsageStatusAsString = function (meteredUsage) {
            if (meteredUsage.IsNewMeteredUsage) {
                return $scope.ITEM_STATUS['Added'];
            }

            return meteredUsage.BilledOn || meteredUsage.BilledInvoiceId ? $scope.ITEM_STATUS['Billed'] : $scope.ITEM_STATUS['NotBilled'];
        };
        $scope.getRatedItemStatusAsString = function (ratedItem) {
            if (ratedItem.IsNewRatedItem) {
                return $scope.ITEM_STATUS['Added'];
            }

            return ratedItem.LineItemId ? $scope.ITEM_STATUS['Billed'] : $scope.ITEM_STATUS['NotBilled'];
        };
    }

    $scope.$watch('order.ChangeDate', function(newValue, oldValue) {
        ContractUpgradeChangesMediator.datePresetName = $scope.datePresetName;
        
        // Editing existing items
        {
            if ($scope.componentSubscriptions && $scope.componentSubscriptions[0]) {
                for (let index = 0; index < $scope.componentSubscriptions.length; ++index) {
                    let currentComponentSubscription = $scope.componentSubscriptions[index];
                    
                    if (currentComponentSubscription.IsCancellingNow || currentComponentSubscription.IsEndingNow) {
                        if (Date.parse(pdateFilter(currentComponentSubscription.StartDate, 'short')) > Date.parse(pdateFilter(newValue, 'short'))) {
                            currentComponentSubscription.EndDate = undefined;
                            $scope.revertCancelItem(currentComponentSubscription);
                        } else {
                            currentComponentSubscription.EndDate = newValue;
                            $scope.setCancelOrEnd(currentComponentSubscription);
                        }
                    }
                }
            }

            if ($scope.discountSubscriptions && $scope.discountSubscriptions[0]) {
                for (let index = 0; index < $scope.discountSubscriptions.length; ++index) {
                    let currentDiscountSubscription = $scope.discountSubscriptions[index];

                    if (currentDiscountSubscription.IsCancellingNow || currentDiscountSubscription.IsEndingNow) {
                        if (Date.parse(pdateFilter(currentDiscountSubscription.StartDate, 'short')) > Date.parse(pdateFilter(newValue, 'short'))) {
                            currentDiscountSubscription.EndDate = undefined;
                            $scope.revertCancelItem(currentDiscountSubscription);
                        } else {
                            currentDiscountSubscription.EndDate = newValue;
                            $scope.setCancelOrEnd(currentDiscountSubscription);
                        }
                    }
                }
            }

            ContractUpgradeChangesMediator.discountUpdates.forEach(function (item) {
                // If we back from confirmation
                if (!item.IsCancellingNow && !item.IsEndingNow) {
                    item.StartDate = newValue;
                }
            });
        }
            
        // Editing newly added items
        {
            $scope.order.Cart.ComponentSubscriptions.forEach(function (item) { return item.StartDate = newValue; });
            ContractUpgradeChangesMediator.recurringComponentUpdates.forEach(function (item) {
                // If we back from confirmation
                if (!item.IsCancellingNow && !item.IsEndingNow && !item.IsActiveUnbilled) {
                    item.StartDate = newValue;
                }
            });

            let discountsToRemove = [];
            $scope.order.Cart.DiscountSubscriptions.forEach(function (item) {
                item.StartDate = newValue;

                // So if newly added discount will be in conflict
                // with existing ones it will be deleted
                if (!$scope.isDiscountPeriodUnique(item)) {
                    discountsToRemove.push(item);
                }
            });
            $scope.order.Cart.DiscountSubscriptions = $scope.order.Cart.DiscountSubscriptions.filter(function (discount) { return !discountsToRemove.includes(discount); });

            $scope.order.Cart.MeteredUsages.forEach(function (item) { return item.DueDate = newValue; });
        }
    });
    
    $scope.next = function() {
        // Top plan selection: plan selected, but no variant provided
        if ($scope.order.Cart.PlanId && !$scope.order.Cart.PlanVariantId) {
            return;
        }

        let isNewComponentSubscriptionBeingAdding = function() {
            return $scope.newComponentSubscription.ComponentId || $scope.newComponentSubscription.Memo;
        };
        
        let isNewMeteredUsageBeingAdding = function() {
            return $scope.newMeteredUsage.ComponentId || $scope.newMeteredUsage.Memo;
        };

        let isNewDiscountBeingAdding = function() {
            return $scope.newDiscountSubscription.DiscountId;
        };
        
        let isNewRatedItemBeingAdding = function() {
            return $scope.newRatedItem.Description || $scope.newRatedItem.PricePerUnit || $scope.newRatedItem.TaxPolicyId;
        };
        
        let isNewCouponBeingAdding = function() {
            return $scope.isNewCouponRequired;
        };
        
        let fillDataAndRedirect = function () {
            if (!$scope.order.EmailTemplateExternalId) {
                $scope.order.EmailTemplateExternalId = 'None';
            }

            ContractUpgradeChangesMediator.planChanged = $scope.order.Cart.PlanVariantId && $scope.order.Cart.PlanVariantId !== $scope.oldContract.PlanVariantId;

            if ($scope.canTrialModeBeApplied()){
                $scope.order.Cart.Trial = $scope.trialMode.id;
                ContractUpgradeChangesMediator.trialMode = $scope.trialMode;
            }
            else {
                //Because of the back functionality
                $scope.order.Cart.Trial = undefined;
                ContractUpgradeChangesMediator.trialMode = {};
            }

            if (!$scope.order.Cart.PlanVariantId) {
                $scope.order.Cart._planId = $scope.oldContract.PlanId;
                $scope.order.Cart._planVariantId = $scope.oldContract.PlanVariantId;
                $scope.order.Cart.Trial = undefined;
                $scope.order.Cart.Quantity = undefined;
            }

            // Add canceled/deleted items to updates
            {
                $scope.componentSubscriptions.forEach(function (component) {
                    if ((component.IsCancellingNow || component.IsEndingNow) &&
                        (component._previousEndDate === undefined || component.EndDate < new Date(Date.parse(component._previousEndDate)))) {
                        component.TotalGross = 0;
                        
                        // TODO: prevent duplicates of canceled when passing to confirmation page
                        ContractUpgradeChangesMediator.addRecurringComponentUpdates(component);
                        
                        if (!$scope.order.Cart.EndComponentSubscriptions.includes(component.Id)) {
                            $scope.order.Cart.EndComponentSubscriptions.push(component.Id);
                        }
                    }
                });
                $scope.discountSubscriptions.forEach(function (discount) {
                    if ((discount.IsCancellingNow || discount.IsEndingNow) &&
                        (discount._previousEndDate === undefined || discount.EndDate < new Date(Date.parse(discount._previousEndDate)))) {
                        if (!ContractUpgradeChangesMediator.discountUpdates.includes(discount)) {
                            ContractUpgradeChangesMediator.addDiscountComponentUpdates(discount);
                        }
                        
                        if (!$scope.order.Cart.EndDiscountSubscriptions.includes(discount.Id)) {
                            $scope.order.Cart.EndDiscountSubscriptions.push(discount.Id);
                        }
                    }
                });
                $scope.meteredUsages.forEach(function (meteredUsage) {
                    if (meteredUsage.IsDeletedNow) {
                        meteredUsage.IsActiveUnbilled = undefined;
                        meteredUsage.TotalGross = 0;

                        if (!$scope.order.Cart.DeletedMeteredUsages.includes(meteredUsage.Id)) {
                            $scope.order.Cart.DeletedMeteredUsages.push(meteredUsage.Id);
                        }
                        ContractUpgradeChangesMediator.addMeteredComponentUpdates(meteredUsage);
                    } else {
                        meteredUsage.IsActiveUnbilled = undefined;

                        if ($scope.order.Cart.DeletedMeteredUsages.includes(meteredUsage.Id)) {
                            $scope.order.Cart.DeletedMeteredUsages = $scope.order.Cart.DeletedMeteredUsages.filter(function (id) { return id !== meteredUsage.Id; });
                        }
                    }
                });

                $scope.ratedItems.forEach(function (ratedItem) {
                    ratedItem.IsActiveUnbilled = undefined;
                    if (ratedItem.IsDeletedNow) {
                        ratedItem.TotalGross = 0;

                        if (!$scope.order.Cart.DeletedRatedItems.includes(ratedItem.Id)) {
                            $scope.order.Cart.DeletedRatedItems.push(ratedItem.Id);
                        }
                        ContractUpgradeChangesMediator.addRatedItemsComponentUpdates(ratedItem);
                    } else {
                        if ($scope.order.Cart.DeletedRatedItems.includes(ratedItem.Id)) {
                            $scope.order.Cart.DeletedRatedItems = $scope.order.Cart.DeletedRatedItems.filter(function (id) {
                                return id !== ratedItem.Id;
                            });
                        }
                    }
                });
            }

            let discountFromCoupon = $scope.order.Cart.DiscountSubscriptions.find(function (item) { return item._fromCoupon; });

            // We must send only CouponCode, not an corresponding applied discount.
            // Previously this discount was added to list only for UI purposes
            if (discountFromCoupon) {
                $scope.order.Cart.DiscountSubscriptions = $scope.order.Cart.DiscountSubscriptions.filter(function (item) { return !item._fromCoupon; });
                ContractUpgradeChangesMediator.addDiscountComponentUpdates(discountFromCoupon);
            }
            
            // Add all items from Cart to updates
            {
                $scope.order.Cart.ComponentSubscriptions.forEach(function (item) {
                    item.TotalGross = 0;
                    
                    ContractUpgradeChangesMediator.addRecurringComponentUpdates(angular.copy(item));
                });
                
                ContractUpgradeChangesMediator.discountUpdates = ContractUpgradeChangesMediator.discountUpdates
                    .filter(function (item) { return !item.IsNewDiscount && !item._fromCoupon; });
                $scope.order.Cart.DiscountSubscriptions.forEach(function (item) {
                    let itemCopy = angular.copy(item);
                    
                    ContractUpgradeChangesMediator.addDiscountComponentUpdates(itemCopy);
                });
                
                $scope.order.Cart.MeteredUsages.forEach(function (item) {
                    item.TotalGross = 0;
                    
                    ContractUpgradeChangesMediator.addMeteredComponentUpdates(angular.copy(item));
                });
                
                $scope.order.Cart.RatedItems.forEach(function (item) {
                    item.TotalGross = 0;

                    ContractUpgradeChangesMediator.addRatedItemsComponentUpdates(item);
                });
            }

            if ($scope.datePresetName === "Preset Date") {
                $scope.datePresetName = "";
            }

            ContractUpgradeChangesMediator.datePresetName = $scope.datePresetName;
            ContractUpgradeChangesMediator.requirePayment = $scope.requirePayment;
            ContractUpgradeChangesMediator.onAccount = $scope.onAccount;
            
            if (ContractUpgradeChangesMediator.isBack) {
                // TODO: delete draft order
                ContractUpgradeChangesMediator.isBack = undefined;
            }

            $http({
                method: "POST",
                url: "/api/v1/orders/",
                params: null,
                data: $scope.order,
                headers: { },
                cache: false
            }).then(
                function (response) {
                    $scope.order._planVariantTotalGross = 0;

                    let unbilledChecksPromises = [];

                    let fillGrossTotalValues = function (order, response) {
                        let lineItems = response.data.LineItems;
                        let ratedItems = response.data.RatedItems;

                        if (lineItems.length === 0 && ratedItems.length === 0) {
                            return;
                        }

                        lineItems.forEach(function (lineItem) {
                            // Sum values for plan variant change
                            if (lineItem.ProductId && lineItem.ProductId === $scope.order.Cart.PlanVariantId ||
                                lineItem.ProductId === $scope.oldContract.PlanVariantId) {
                                $scope.order._planVariantTotalGross += lineItem.TotalGross;

                                return;
                            }

                            let isAnyComponentFound = false;
                            
                            // Add unbilled active component subscriptions to confirmation table
                            $scope.componentSubscriptions
                                .filter(function (component) { return !component.IsCancellingNow && !component.IsEndingNow; })
                                .forEach(function (component) {
                                    component.TotalGross = 0;
                                    
                                    unbilledChecksPromises.push(
                                        ComponentSubscription.get({ componentSubscriptionId: component.Id }).$promise.then(function (recievedComponent) {
                                            if (component.Id === recievedComponent.Id &&
                                                recievedComponent.Id === lineItem.ComponentSubscriptionId &&
                                                !recievedComponent.BilledUntil) {
                                                component.TotalGross += lineItem.TotalGross;
                                                component.IsActiveUnbilled = true;
    
                                                // Hack!!!
                                                if (!ContractUpgradeChangesMediator.recurringComponentUpdates.includes(component)) {
                                                    ContractUpgradeChangesMediator.addRecurringComponentUpdates(component);
                                                }
    
                                                isAnyComponentFound = true;
                                            }
                                        }));
                                });

                            if (isAnyComponentFound) {
                                return;
                            }

                            // Sum values for canceled/ended component subscriptions
                            ContractUpgradeChangesMediator.recurringComponentUpdates
                                .filter(function (component) { return component.IsCancellingNow || component.IsEndingNow; })
                                .forEach(function (component) {
                                    let lineItemUTCDate = new Date(lineItem.PeriodEnd);
                                    let orderChangeDateLocal = new Date($scope.order.ChangeDate);

                                    if ((!component.Id || component.Id === lineItem.ComponentSubscriptionId) &&
                                        component.ComponentId === lineItem.ProductId &&
                                        component.Quantity === lineItem.ScaleAmount &&
                                        PUtill.areDatesEqual(lineItemUTCDate, orderChangeDateLocal))
                                    {
                                        component.Id = lineItem.ComponentSubscriptionId;
                                        component.TotalGross += lineItem.TotalGross;

                                        isAnyComponentFound = true;
                                    }
                                });

                            if (isAnyComponentFound)
                                return;
                            
                            let activeMetereds = $scope.meteredUsages.filter(function (meteredUsage) { return meteredUsage.IsDeletedNow === undefined; });
                            activeMetereds.forEach(function (meteredUsage) {
                                meteredUsage.TotalGross = 0;
                                unbilledChecksPromises.push(
                                    ContractUnbilledMeteredLineItemsForUpgradeProcess.get({
                                        contractId: $scope.order.ContractId,
                                        upgradeDate: JSON.parse(angular.toJson($scope.order.ChangeDate))
                                    }).$promise.then(function (invoicePreview) {
                                        let receivedMetereds = invoicePreview.Entries.flatMap(a => a.ItemList);

                                        receivedMetereds.forEach(function (receivedMetered) {
                                            if (meteredUsage.Id === receivedMetered.MeteredUsageId &&
                                                receivedMetered.MeteredUsageId === lineItem.MeteredUsageId &&
                                                !receivedMetered.BilledUntil) {
                                                meteredUsage.TotalGross += lineItem.TotalGross;
                                                meteredUsage.IsActiveUnbilled = true;

                                                // Hack!!!
                                                if (!ContractUpgradeChangesMediator.meteredComponentsUpdates.includes(meteredUsage))
                                                    ContractUpgradeChangesMediator.addMeteredComponentUpdates(meteredUsage);

                                                isAnyComponentFound = true;
                                            }                                                
                                        });
                                    }));
                            });

                            if (isAnyComponentFound)
                                return;

                            // Sum values for added component subscriptions
                            ContractUpgradeChangesMediator.recurringComponentUpdates
                                .filter(function (component) { return component.IsNewComponent; })
                                .forEach(function (component) {
                                    if ((!component.Id || component.Id === lineItem.ComponentSubscriptionId) &&
                                        lineItem.Quantity > 0 && component.ComponentId === lineItem.ProductId &&
                                        component.Quantity === lineItem.ScaleAmount) {
                                        component.Id = lineItem.ComponentSubscriptionId;
                                        component.TotalGross += lineItem.TotalGross;

                                        isAnyComponentFound = true;
                                    }
                                });

                            if (isAnyComponentFound)
                                return;

                            // Sum values for added rated items
                            ContractUpgradeChangesMediator.ratedItemsUpdates.forEach(function (rated) {
                                //Adding below extra if condition for updating total gross of existing unbilled item,
                                //total gross gets reset when deleted, after restoring it shows 0 hence setting total
                                //gross again from line Item. With existing If condition (now else if) it will add amount again
                                //and will make it double for non deleted unbilled rated item.
                                let baseMatchItemCondition = rated.PricePerUnit === lineItem.PricePerUnit &&
                                    rated.Quantity === lineItem.Quantity &&
                                    rated.TaxPolicyId === lineItem.TaxPolicyId;
                                let existingRateItemCondition = rated.Description === lineItem.Description &&
                                    rated.IsActiveUnbilled === true &&
                                    rated.TotalGross === 0;

                                if ((baseMatchItemCondition && existingRateItemCondition) || (baseMatchItemCondition && !rated.IsActiveUnbilled)) {
                                    rated.TotalGross += lineItem.TotalGross;
                                }
                            });

                            // Sum values for added metered usages payed with triggered interim billing
                            ContractUpgradeChangesMediator.meteredComponentsUpdates
                                .filter(function (component) { return component.IsNewMeteredUsage; })
                                .forEach(function (metered) {                                    
                                    if ((!metered.Id || metered.Id === lineItem.MeteredUsageId) &&
                                        metered.Quantity === lineItem.Quantity &&
                                        metered.ComponentId === lineItem.ProductId) {
                                        metered.Id = lineItem.MeteredUsageId
                                        metered.TotalGross += lineItem.TotalGross;
                                    }
                                });
                        });
                    };

                    $scope.order.Id = response.data.Id;
                    $scope.order.TotalGross = response.data.TotalGross;
                    $scope.order.NextTotalGross = response.data.NextTotalGross;
                    $scope.order.NextTotalGrossDate = response.data.NextTotalGrossDate;

                    //Adding existing unbilled rated Item to collection so it can be taken to confirmation page.
                    $scope.ratedItems.forEach(function (ratedItem) {
                        if (ratedItem.IsActiveUnbilled === undefined) {
                            ratedItem.IsActiveUnbilled = true;
                            ContractUpgradeChangesMediator.addRatedItemsComponentUpdates(ratedItem);
                        }
                    });
                    
                    $scope.order._totalNet = response.data.LineItems.reduce(function (result, item) { return result + item.TotalNet; }, 0);
                    $scope.order.TotalVat = response.data.TotalVat;

                    fillGrossTotalValues($scope.order, response);

                    Promise.all(unbilledChecksPromises).then(function () {
                        if (discountFromCoupon) {
                            // TODO: place to position (in table) where it was deleted
                            $scope.order.Cart.DiscountSubscriptions.push(discountFromCoupon);
                        }
                        
                        ContractUpgradeChangesMediator.order = $scope.order;
                        $location.path("/contracts/" + $routeParams.contractId + "/upgrade/confirm");
                        
                        // Called to execute $location in the scope of promised object
                        $rootScope.$apply();
                    });
                },
                function () {
                    if (discountFromCoupon) {
                        // TODO: place to position (in table) where it was deleted
                        $scope.order.Cart.DiscountSubscriptions.push(discountFromCoupon);
                        ContractUpgradeChangesMediator.removeDiscountComponentUpdates(discountFromCoupon.$$hashKey);
                    }
                });
        };

        let paymentCheck = function() {
            if ($scope.requirePayment && (!$scope.oldContract.PaymentProvider || $scope.oldContract.PaymentProvider === "")) {
                $scope.yesCancel(gettextCatalog.getString(gettext("Payment method required")),
                    gettextCatalog.getString(gettext("This order requires a payment method to be set. Should it be set to 'On Account'?")),
                    function () {
                        $scope.onAccount = true;
                        fillDataAndRedirect();
                    }
                );
            } else {
                $scope.onAccount = false;
                fillDataAndRedirect();
            }
        };
        
        if (isNewDiscountBeingAdding() ||
            isNewMeteredUsageBeingAdding() ||
            isNewComponentSubscriptionBeingAdding() ||
            isNewRatedItemBeingAdding() ||
            isNewCouponBeingAdding()) {
            $scope.yesCancel(
                gettextCatalog.getString(gettext("Upgrade/Downgrade Contract")),
                gettextCatalog.getString(gettext("There are still items that have been selected but not added properly, are you sure you want to continue without adding them?")),
                function () {
                    paymentCheck();
                }
            );
        } else {
            paymentCheck();            
        }
    };
    $scope.cancel = function() {
        $scope.yesCancel(gettextCatalog.getString(gettext("Upgrade/Downgrade Contract")),
            gettextCatalog.getString(gettext("You are going to cancel the Up/Downgrade process. All changes will be lost. Are you sure?")),
            function () {
                $location.path("/contracts/" + $routeParams.contractId);
            }
        );
    };
    $scope.back = function() {
        $location.path("/contracts/" + $routeParams.contractId);
    };

    $scope.isPriceListItemDisabled = function (priceList) {
        if (!priceList.Items || !$scope.priceList)
            return true;

        let price = priceList.Items.find(item => item.ProductId === $scope.order.Cart.PlanVariantId)
            || priceList.ParentItems?.find(item => item.ProductId === $scope.order.Cart.PlanVariantId);
        let isPriceDefined = price != null && price.OneOffPrice != null && price.RecurringPrice != null;

        return priceList.Currency !== $scope.priceList.Currency
            || !isPriceDefined;
    }

    $scope.clearNewComponentSubscription();
    $scope.clearNewDiscountSubscription();
    $scope.clearNewMeteredUsage();
    $scope.clearNewRatedItem();

    $scope.$on("$destroy", function () {
        // True only on first load of upgrade page
        if (ContractUpgradeChangesMediator.isBack === false)
            ContractUpgradeChangesMediator.reset();
    });
};

ContractUpgradeController.$inject = ['$rootScope', '$scope', '$location', '$routeParams', '$http', '$filter', 'ProductInfo', 
    'Contract', 'Order', 'Component', 'gettext', 'gettextCatalog', 'ContractTimeDetails', 
    'PUtill', 'EmailNotificationsTemplatesByEventCategory','babelFilter', 'ContractUpgradeChangesMediator',
    'ComponentSubscriptionByContract', 'ComponentSubscription', 'ComponentUsage', 'DiscountSubscriptionByContract', 'ContractRatedItems', 'Coupons',
    'pdateFilter', 'ContractUnbilledMeteredLineItemsForUpgradeProcess', 'ContractEndDate', 'DatepickerUtils'];
